// ForgetPassword.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import './ResponsiveLogin.css';
import './CreatePrescription.css';
import Logo from '../assets/img/Logo.png';
import BG from '../assets/img/bg.png';
import { Link } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

function ForgetPassword() {
  const [step, setStep] = useState(1); // Track the current step: 1 for email input, 2 for OTP and password reset
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const validatePassword = (password) => {
      const minLength = 8;
      const hasNumber = /\d/;
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

      if (password.length < minLength || !hasNumber.test(password) || !hasSpecialChar.test(password)) {
          return false;
      }
      return true;
  };

  // Step 1: Send OTP to email
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      const response = await toast.promise(
          axios.get(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/send_otp_password/${email}/`),
          {
            loading: 'Sending OTP by mail...',
            success: <b>OTP has been sent to your email!</b>,
            error: <b>Failed to send OTP. Please try again.</b>,
          }
      );

      //const response = await axios.get(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/send_otp_password/${email}/`);

      if (response.data.status === 1) {
        setMessage('OTP has been sent to your email.');
        setStep(2); // Move to the next step to enter OTP and new password
      } else {
        setError('Failed to send OTP. Please try again.');
      }
    } catch (err) {
      setError('Error sending OTP. Please make sure the email is correct.');
    }
  };

  const reloadPage = () => {
    window.location.reload();
  }
  // Step 2: Verify OTP and reset password
  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (!validatePassword(newPassword)) {
        setError('Password must be at least 8 characters long and include numbers and special characters.');
        return;
    }

    setError('');
    setMessage('');
    try {
      const response = await axios.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/forgot-password`, {
        username: email,
        code: otp,
        password: newPassword,
      });
      if (response.data.status === 1) {
        setMessage('Password has been reset successfully. Redirecting to login...');
        setTimeout(() => navigate('/'), 2000); // Redirect to login after success
      } else {
        setError('Invalid OTP or OTP expired. Please try again.');
      }
    } catch (err) {
      setError('Error resetting password. Please try again.');
    }
  };

  return (
    <div className="login-container create-prescription">
      <div className="login-left">
        <img
          src={BG}
          alt="Forgot Password"
          className="login-image"
        />
      </div>
      <div className="login-right">
        <div className="login-form">
          <img src={Logo} alt="Sneho Health Logo" className="logo-image login-page" />
          {message && <div className="message">{message}</div>}
          {step === 1 ? (
            // Step 1: Email Input for Sending OTP
            <form onSubmit={handleSendOtp} className="login-form">
              <div className="form-group">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                  placeholder="Enter your email"
                  required
                />
                <label>Email Address:</label>
              </div>
              {error && <div className="error">{error}</div>}
              <button type="submit" className="btn btn-primary">Send OTP</button>
            </form>
          ) : (
            // Step 2: OTP and New Password Input
            <form onSubmit={handleResetPassword} className="login-form">
              <div className="form-group">
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="form-control"
                  placeholder="Enter the OTP"
                  required
                />
                <label>OTP:</label>
              </div>
              <div className="form-group">
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="form-control"
                  placeholder="Enter new password"
                  required
                />
                <label>New Password:</label>
              </div>
              {error && <div className="error">{error} <Link onClick={reloadPage}>Re-send OTP</Link></div>}
              <button type="submit" className="btn btn-primary">Reset Password</button>
            </form>
          )}
          <Toaster
            position="top-right"
            reverseOrder={true}
          />
          <div className="form-links">
            <a href="/">Back to Login</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
